import { render, staticRenderFns } from "./ForumCatList.vue?vue&type=template&id=727122d8&scoped=true"
import script from "./ForumCatList.vue?vue&type=script&lang=ts"
export * from "./ForumCatList.vue?vue&type=script&lang=ts"
import style0 from "./ForumCatList.vue?vue&type=style&index=0&id=727122d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727122d8",
  null
  
)

export default component.exports